module.exports = __webpack_public_path__ + "img/1.524fdb7f.jpg";